import { IAppointmentModel } from 'models/Appointment.Model';
import { IAppointmentSlotModel } from 'models/AppointmentSlot.Model';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams, } from 'react-router-dom';
import CommonService from 'services/CommonService';
import { ResponsiveItemPerView, aes_encryption, aes_decryption, decryptOrderId, encryptOrderId, getCountryCodeStorage, getStatusIds, isIn, isMobile, onSpaceDown } from '../../helpers/Helper';

import { Card, CardBody, Col, Container, Modal, Row } from 'reactstrap';
import { CustomButton } from 'components/shared/CustomButton';
import UserAddressServices from 'services/UserAddress.Services';
import { IAddressModel } from 'models/Address.Model';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { HelperConstant } from '../../helpers/HelperConstant';
import NewAddressForm from './NewAddressForm';
import CustomLoader from 'components/Common/CustomLoader';
import { CustomTextArea } from 'components/shared/CustomTextArea';
import EnquiryServices from 'services/Enquiry.Services';
import Loader from 'components/Common/Loader';

function OrderSchedules() {

    document.title = "Schedule | DOFY-Admin";
    const { encryptedId} = useParams<any>();
    const [searchParams] = useSearchParams();
    const dashboardStatusId = searchParams.get('dashboardStatusId') as any;
    const navigate = useNavigate();
    const orderId = decryptOrderId(encryptedId);
    const currentDate = new Date();

    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    const [orderSummaryInfo, setOrderSummaryInfo] = useState<IGetOrderSummaryModel>();
    const [isLoad, setisLoad] = useState<boolean>(false);
    let Cmonth = moment().format("MMMM").toString();

    const [searchText, setSearchText] = useState<any>("");
    const [filteredData, setfilteredData] = useState<Array<IAddressModel>>([]);
    const [defaultvalue, setDefaultValue] = useState<IAddressModel>({} as IAddressModel);
    const [defaultShow, setDefaultShow] = useState<boolean>(false);
    const [slotDate, setSlotDate] = useState<any>();
    const [slotSession, setSlotSession] = useState({ StartTime: "", EndTime: "", Id: 0 });
    const [slotList, setSlotList] = useState<Array<IAppointmentSlotModel>>([]);
    const [selectedAddressId, setSelectedAddressId] = useState(0);
    const [showLoading, setShowLoading] = useState(true);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isAdd, setIsAdd] = useState(false);
    const [changesInAddress, setChangesInAddress] = useState<boolean>(false);
    const [personId, setPersonId] = useState(0);
    const [removedId, setRemovedId] = useState<any>(0);
    const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
    const [stateList, setStateList] = useState<Array<any>>([]);
    const [dubaiStateList, setDubaiStateList] = useState<Array<any>>([]);
    const [customerUserId, setCustomerUserId] = useState({ Id: 0, UserName: '', UserMobile: 0 });
    const [userAddressId, setUserAddressId] = useState<number>(0);
    const [comments, setComments] = useState<string>("");

    const pendingIds =  `${HelperConstant.StatusId.PENDING},${HelperConstant.StatusId.PUBLICRECALCULATION},${HelperConstant.StatusId.ADMINCRECALCULATION}`; 
    const selectSlot = (addressId: any) => {
        getAppointmentSlotList(orderSummaryInfo?.ProductTypeId, orderSummaryInfo?.ServiceTypeId, false, addressId);
    }

    const filterAddresshandler = (id: any) => {
        let data = filteredData.find(x => x.Id == id) as IAddressModel;
        setDefaultValue(data);
        setTimeout(() => { setDefaultShow(false); }, 100);
        setTimeout(() => { setDefaultShow(true); }, 200);
    }

    const getAppointmentSlotList = (productTypeId: number, serviceTypeId: number, isExpressPickup: boolean, userAddresId: number) => {
        CommonService.postWithPentaParams("Appointmentslots", "GetAppointmentSlots", 'date', moment(currentDate).format('yyyy-MM-DD HH:mm'), 'productTypeId', productTypeId, 'serviceTypeId', serviceTypeId, 'isExpressPickup', isExpressPickup, 'userAddressId', userAddresId).then(res => {
            if (res.status === 200) {
                const decryptedData = aes_decryption(res.data);
                setSlotList(JSON.parse(decryptedData));
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetOrderSummary = () => {
        setShowLoading(true)
        CommonService.getWithSingleEntity('sell', 'GetOrderSummary', encryptedId).then(res => {
            if (res.status === 200) {
                let data = res.data as IGetOrderSummaryModel;
                setOrderSummaryInfo(res.data);
                setPersonId(data.PersonId);
                setCustomerUserId({ Id: data.Id, UserName: data.UserName, UserMobile: data.UserMobile });
                setShowLoading(false)
                if (data.Appointment?.UserAddresId) {
                    setUserAddressId(data.Appointment?.UserAddresId);
                    setSelectedAddressId(data.Appointment?.UserAddresId);
                    setSlotSession({ StartTime: "", EndTime: "", Id: 0 });
                    setSlotDate("");
                    getAppointmentSlotList(data.ProductTypeId, data.ServiceTypeId, false, data.Appointment?.UserAddresId)
                }

            }
        })
    }

    const AdminReEvaluteOrder = () => {
        setShowLoading(true)
        EnquiryServices.AdminReEvaluteOrder(encryptedId).then(res => {
            if (res.status === 200) {
                let data = res.data as IGetOrderSummaryModel;
                setOrderSummaryInfo(res.data);
                setPersonId(data.PersonId);
                setCustomerUserId({ Id: data.Id, UserName: data.UserName, UserMobile: data.UserMobile });
                setShowLoading(false)
                if (data.Appointment?.UserAddresId) {
                    setUserAddressId(data.Appointment?.UserAddresId);
                    setSelectedAddressId(data.Appointment?.UserAddresId);
                    setSlotSession({ StartTime: "", EndTime: "", Id: 0 });
                    setSlotDate("");
                    getAppointmentSlotList(data.ProductTypeId, data.ServiceTypeId, false, data.Appointment?.UserAddresId)
                }
            }
        }).catch(e => console.error(e))
    }

    const addressHandler = (addressId: any, type: "view" | "edit") => {
        if (type === "view") {
            setIsEdit(false);
            filterAddresshandler(addressId);
        }
        if (type === "edit") {
            setIsEdit(true);
            setIsAdd(true)
            filterAddresshandler(addressId);

        }
    }
    const addNewAddressHandler = () => {
        setIsEdit(false);
        setIsAdd(true)
        setDefaultValue({} as IAddressModel);
        setTimeout(() => { setDefaultShow(false); }, 100);
        setTimeout(() => { setDefaultShow(true); }, 200);
    }

    const [isMultiClickDisable,setIsMultiClickDisble] = useState(false);

    const slotHandler = () => {
        setIsMultiClickDisble(true);
        let appointmentData: IAppointmentModel = {
            Id: 0,
            Created: "2022-04-13T14:40:43.424Z",
            CreatedBy: 0,
            Active: true,
            Modified: "2022-04-13T14:40:43.424Z",
            ModifiedBy: 0,
            ValidationErrors: {},
            // OrderId: getStatusIds(parseInt(dashboardStatusId)) == HelperConstant.StatusId.PENDING ? parseInt(orderId as any) : parseInt(orderSummaryInfo?.EnquiryId as any),
            OrderId: 0,
            AssigneeId: null,
            UserAddresId: selectedAddressId,
            AppointmentDate: slotDate,
            StartTime: slotSession.StartTime,
            EndTime: slotSession.EndTime,
            Remarks: "",
            TechnicianComments: "",
            RowOrder: 0,
            IsReschedule: true,
            AppointmentCity: "",
            AppointmentPincode: 0,
            address: "",
            Comments: comments,

        };
        let order_id = getStatusIds(parseInt(dashboardStatusId)) == pendingIds ? encryptedId : aes_encryption(orderSummaryInfo?.EnquiryId);
        CommonService.postWithEntityandSingleQueryParam("Sell", "ScheduledByTelecaller", appointmentData, "encryptedOrderId", order_id).then(res => {
            if (res.status === 200) {
                navigate(`/agent-ticket-view/${aes_encryption(res.data)}?dashboardStatusId=2`)
            }
        }).catch((e: string) => {
            console.log(e)
        });
    }

    const RemoveAddressHandler = (addressId: any) => {
        UserAddressServices.remove(addressId).then(res => {
            if (res.status === 200)
                window.location.reload();
        }).catch((e: string) => {
            console.log(e)
        });
    }

    useEffect(() => {
        setChangesInAddress(changesInAddress);
    }, [changesInAddress]);


    useEffect(() => {
        const searchFilter = (data: Array<IAddressModel>, searchString: string) => {
            if (searchText === "") {
                return setfilteredData(data);
            }
            var resultArray = Array<IAddressModel>();
            data.forEach((data, i) => {
                let strings = `${data?.Name} ${data.Address} ${data.Address1} ${data.LandMark} ${data.LocationPin} ${data.MobilePhone} ${data.PinCode}`;
                if (strings.toLowerCase().includes(searchText.toLowerCase())) {
                    return resultArray.push(data);
                }
            })

            setfilteredData(resultArray);
            return resultArray;
        }

        const GetAddress = (personId: any) => {
            setShowLoading(true)
            UserAddressServices.GetPersonAddress(personId).then(res => {
                if (res.status === 200) {
                    searchFilter(res.data.Items, searchText);
                    setShowLoading(false)
                }
                if (res.data.Items <= 0) {
                    setDefaultShow(true);
                }
            }).catch(e => { console.log(e) })
        }

        setDefaultShow(defaultShow);
       
        GetAddress(aes_encryption(personId))

    }, [personId, searchText, defaultShow])

    useEffect(() => {
        const GetAllStateList = (serviceTypeId: number) => {
            CommonService.getWithQueryParam("master", "GetStateList", "serviceTypeId", serviceTypeId).then(res => {
                if (res.status === 200) {
                    setStateList(res.data);
                };
            }).catch(e => console.log(e));
        }

        const getCityList = () => {
            CommonService.getWithQueryParam("master", "GetCityList", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then(res => {
                if (res.status === 200) {
                    setDubaiStateList(res.data);
                }
            }).catch(e => {
                console.log(e);
            });
        }

        getCityList();
        GetAllStateList(HelperConstant.serviceTypeId.SELL);
    }, []);


    useEffect(() => {
       
        if (getStatusIds(parseInt(dashboardStatusId)) == pendingIds) {
            AdminReEvaluteOrder();
        } else {
            GetOrderSummary();
        }
    }, [])

    const GetSlots = () => {
        return <Swiper slidesPerView={ResponsiveItemPerView(2, 4, 3.5)} modules={[Navigation]} pagination={{ clickable: true }} rewind={false} navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
        }}>
            {slotList.filter((value, index, self) => index === self.findIndex((t) => (t.EventDate === value.EventDate)))
                .map((val, i) => (
                    <SwiperSlide key={i}>
                        <>
                            {moment(val.EventDate).format("MMM Do YY") === moment(currentDate).format("MMM Do YY") ?
                                <div className={`${slotDate == val.EventDate ? 'slot-box-active' : 'slot-box'} cursor-pointer`} onClick={() => setSlotDate(val.EventDate)}>
                                    <div className='text-center'>
                                        <p className="fw-semibold m-0 font-size-13">
                                            Express Pickup
                                        </p>
                                    </div>
                                </div>
                                :
                                <div className={`${slotDate == val.EventDate ? 'slot-box-active' : 'slot-box'} cursor-pointer`} onClick={() => setSlotDate(val.EventDate)}>
                                    <div >
                                        <p className="fw-semibold m-0 font-size-14">
                                            {moment(val.EventDate).format("ddd")}
                                        </p>
                                        <p className="fw-bolder m-0 font-size-16" style={{ marginTop: '-3px' }}>
                                            {moment(val.EventDate).format('D')?.toString().padStart(2, "0")}
                                        </p>
                                    </div>
                                </div>}
                        </>
                    </SwiperSlide>
                ))}
        </Swiper>

    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>ORDER SCHEDULES</h5>
                    </div>
                    <CustomLoader isOpen={showLoading} />
                    <Row>
                        <Col xl='6' lg='6'>
                            <Card className='bg-light shadow-none p-1' >
                                <CardBody >
                                    <p className='m-0 fw-semibold text-dofy'>Select a pickup address from your address list</p>
                                    {defaultShow && <NewAddressForm personAddressInfo={filteredData} isEdit={isEdit} isAdd={isAdd} setIsAdd={setIsAdd} defaultValues={defaultvalue} publicUserUniques={customerUserId} personId={personId} />}
                                    <CustomButton onClick={() => addNewAddressHandler()} color="warning" type={'button'} btnClassName={'btn-success my-1'} iconClasssName={undefined} name={'Add Address'} />
                                    <div className='my-2 slot-address-cards'>
                                        <div className='font-size-12' >
                                            {filteredData && filteredData.length > 0 &&
                                                <>
                                                    {filteredData.sort((a, b) => b.Id - a.Id).map((val: IAddressModel, i: number) => {
                                                        return <Row key={i}>
                                                            {isIn() ?
                                                                <Col xl='12'>
                                                                    <div className={`rounded-2 cursor-pointer ${selectedAddressId == val.Id ? 'radio-card' : 'radio-card-not-checked'}`} >
                                                                        <Row>
                                                                            <Col xl={9} lg={9} md={8} sm={12} xs={12} onClick={() => { setSelectedAddressId(val.Id); setSlotSession({ StartTime: "", EndTime: "", Id: 0 }); setSlotDate(""); selectSlot(val.Id); }}>
                                                                                <p className='m-0 fw-semibold'>{val.Name} </p>
                                                                                {val.Address},&nbsp;
                                                                                {val.Address1 && <>{val.Address1},&nbsp;</>}
                                                                                {val.LandMark && <>{val.LandMark},&nbsp;</>}
                                                                                {(stateList.length > 0) && <>{stateList.find(x => x.Id === val.StateId)?.Name} - {val.PinCode ? val.PinCode : val.LocationPin}</>},&nbsp;
                                                                                <p className='m-0'>{getCountryCodeStorage() == "in" ? "+91" : "+971"} {val.MobilePhone} </p>
                                                                            </Col>
                                                                            <Col xl={1} lg={1} md={2} sm={6} xs={6} className='text-center'>
                                                                                <i className='bx bx-edit font-size-18' onClick={() => addressHandler(val.Id, "edit")}></i>
                                                                            </Col>
                                                                            <Col xl={1} lg={1} md={2} sm={6} xs={6} className='text-center'>
                                                                                <i className='bx bx-trash font-size-18' onClick={() => { setRemovedId(val.Id); setIsRemoveModalOpen(true) }}></i>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Col> :
                                                                <Col xl='12'>
                                                                    <div className={`rounded-2 cursor-pointer ${selectedAddressId == val.Id ? 'radio-card' : 'radio-card-not-checked'}`} >
                                                                        <Row>
                                                                            <Col xl={9} lg={9} md={8} sm={12} xs={12} onClick={() => { setSelectedAddressId(val.Id); setSlotSession({ StartTime: "", EndTime: "", Id: 0 }); setSlotDate(""); selectSlot(val.Id); }}>
                                                                                <p className='m-0 fw-semibold'>{val.Name} </p>
                                                                                {val.Address},&nbsp;
                                                                                {val.Address1 && <>{val.Address1},&nbsp;</>}
                                                                                {val.LandMark && <>{val.LandMark},&nbsp;</>}
                                                                                {dubaiStateList.find(x => x.Id === val.StateId)?.Name} - {val.PinCode},<br />
                                                                                <p className='my-1'>{getCountryCodeStorage() == "in" ? "+91" : "+971"} {val.MobilePhone} </p>
                                                                            </Col>
                                                                            <Col xl={1} lg={1} md={2} sm={6} xs={6} className='text-center'>
                                                                                <i className='bx bx-edit font-size-18' onClick={() => addressHandler(val.Id, "edit")}></i>
                                                                            </Col>
                                                                            <Col xl={1} lg={1} md={2} sm={6} xs={6} className='text-center'>
                                                                                <i className='bx bx-trash font-size-18' onClick={() => { setRemovedId(val.Id); setIsRemoveModalOpen(true) }}></i>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Col>}
                                                        </Row>
                                                    })}
                                                </>}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl='6' lg='6'>
                            <Card className='bg-light shadow-none p-0'>
                                <CardBody>
                                    <p className='m-0 fw-semibold text-dofy'>Please schedule the convenient time for pickup</p>
                                    <h5 className='fw-bold text-dark my-2'>{Cmonth}</h5>
                                    {GetSlots()}
                                    <div className='row mt-3 gx-2'>
                                        {slotList.filter(it => it.EventDate === slotDate).map((val: IAppointmentSlotModel, idx: number) => (
                                            <div key={idx} style={{ borderRadius: '10px' }} className={`col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 py-2 mb-2 cursor-pointer ${slotSession.Id == val.Id ? 'slot-segment-active' : 'slot-segment-passive'}`} onClick={() => { setSlotSession({ StartTime: val.StartTime, EndTime: val.EndTime, Id: val.Id }) }}>
                                                <div className={`cursor-pointer text-center`}>
                                                    <p className={`mb-0 py-2 text-nowrap segment-text dofy-admin-font-sm`}>{moment(val.StartTime).format('LT')} TO {moment(val.EndTime).format('LT')}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </CardBody>
                            </Card>
                            <Card className='bg-light shadow-none p-0'>
                                <CardBody>
                                    <p className='m-0 fw-semibold text-dofy'>Comments</p>
                                    <CustomTextArea label={undefined} id={'comments'} name={'comments'} value={comments} error={undefined} onChange={(e) => setComments(e.target.value)} onKeyDown={(e) => comments.length == 0 && onSpaceDown(e)}/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <div>
                        {!isMobile() ?
                            <div className='d-flex justify-content-end'>
                                <CustomButton type={'button'} btnClassName={'btn-soft-dark me-2'} iconClasssName={undefined} name={'Cancel'} onClick={() => navigate(`/agent-ticket-view/${encryptedId}?dashboardStatusId=${dashboardStatusId}`)} />
                                {(slotSession.EndTime !== "" && slotSession.StartTime !== "") &&
                                    <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Schedule'} disabled={isMultiClickDisable || (comments.length > 0 ? false : true)} onClick={slotHandler} />}
                            </div> :
                            <div className='d-flex flex-column my-1 mt-3 gap-2'>
                                {(slotSession.EndTime !== "" && slotSession.StartTime !== "") &&
                                    <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Schedule'} disabled={!comments || isMultiClickDisable} onClick={slotHandler} />
                                }
                                <CustomButton type={'button'} btnClassName={'btn-soft-dark'} iconClasssName={undefined} name={'Cancel'} onClick={() => navigate(`/agent-ticket-view/${encryptedId}?dashboardStatusId=${dashboardStatusId}`)} />
                            </div>}
                    </div>
                    <Modal isOpen={isRemoveModalOpen} centered size='sm' backdrop>
                        <div className='modal-content'>
                            <div className='modal-body text-center'>
                                <i className='dripicons-information fs-1 fw-bold text-danger mb-0'></i>
                                <p className='fw-bold font-size-18 mb-0 text-dofy'>Are you sure? </p>
                                <p className='text-muted fw-semibold font-size-12 mb-1'>Are you sure to delete this customer address?</p>
                                <div className="my-2 d-flex justify-content-center">
                                    <CustomButton
                                        type="button"
                                        btnClassName="ms-2 btn-soft-secondary w-md me-2 ms-2 "
                                        iconClasssName="mdi mdi-close"
                                        name=""
                                        onClick={() => setIsRemoveModalOpen(false)}
                                    />
                                    <CustomButton
                                        type="button"
                                        btnClassName=" btn btn-success w-md"
                                        iconClasssName="bx bx-trash font-size-18"
                                        name=""
                                        onClick={() => RemoveAddressHandler(removedId)}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default OrderSchedules
